import { useEffect, useRef, useState } from 'react';
import { ENVIRONMENTS } from '../../services/exports/Constants';

const usePageHeader = () => {
  const showEnvBanner: boolean = import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD;
  const [headerHeight, setHeaderHeight] = useState(0);
  const [identityRowHeight, setIdentityRowHeight] = useState(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    const headerEl = document.getElementById('page-header');
    const identityEl = document.getElementById('header-identity-row');

    const update = () => {
      if (headerEl) setHeaderHeight(headerEl.offsetHeight);
      if (identityEl) setIdentityRowHeight(identityEl.offsetHeight);
    };

    update();

    observerRef.current = new ResizeObserver(update);
    if (headerEl) observerRef.current.observe(headerEl);
    if (identityEl) observerRef.current.observe(identityEl);

    return () => observerRef.current?.disconnect();
  }, []);

  const bannerHeight = showEnvBanner ? (document.getElementById('env-banner')?.offsetHeight ?? 0) : 0;

  return {
    showEnvBanner,
    headerHeight,
    identityRowHeight: identityRowHeight + bannerHeight,
    pageHeaderHeight: {
      desktop: headerHeight,
    },
  };
};

export default usePageHeader;
